$(document).ready(function () {
    $(".template-index .list_collection_home").slick({
        dots: !1,
        infinite: !0,
        speed: 300,
        slidesToShow: 6,
        nav: !0,
        slidesToScroll: 1,
        prevArrow:
            '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg>',
        nextArrow:
            '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg>',
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 5, slidesToScroll: 3, infinite: !0, dots: !1 } },
            { breakpoint: 1250, settings: { slidesToShow: 4, slidesToScroll: 3, infinite: !0, dots: !1 } },
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: !0, dots: !1 } },
            { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 500, settings: { slidesToShow: 1, dots: !1, slidesToScroll: 1 } },
        ],
    }),
        $(".custom-hotspot-icon").click(function () {
            var e = $(this).attr("id");
            $(".hotspot-product ").each(function () {
                var t = $(this).attr("data-id");
                e == t ? $(this).fadeToggle("500") : $(this).fadeOut("500");
            });
        });

  
});
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
console.log(items),
    items.forEach((e) => {
        e.addEventListener("mouseover", () => {
            e.setAttribute("open", !0),
                e.querySelector("ul").addEventListener("mouseleave", () => {
                    e.removeAttribute("open");
                }),
                e.addEventListener("mouseleave", () => {
                    e.removeAttribute("open");
                });
        });
    }),
    $(document).ready(function () {
        $(".right_submenu").hover(
            function () {
                $(this).attr("open", "");
            },
            function () {
                $(this).removeAttr("open");
            }
        );
    }),
    $(document).ready(function () {
        $(".left_menu").hover(
            function () {
                $(this).attr("open", "");
            },
            function () {
                $(this).removeAttr("open");
            }
        );
        var e = 0;
        $(".link__hover.our-brands").on("click", function () {
            0 == e ? (e = new Date().getTime()) : new Date().getTime() - e < 800 ? ((window.location.href = "/pages/our-brand"), (e = 0)) : ((e = new Date().getTime()), (window.location.href = "/pages/our-brand"));
        });
    });
